import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CreationSiteInternetParis from "../pages/creation-site-internet-paris/page";
import ConceptionLogoParis from "../pages/conception-logo-paris/page";
import RefonteSiteWebParis from "../pages/refonte-site-web-paris/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/creation-site-internet-paris",
    element: <CreationSiteInternetParis />,
  },
  {
    path: "/conception-logo-paris",
    element: <ConceptionLogoParis />,
  },
  {
    path: "/refonte-site-web-paris",
    element: <RefonteSiteWebParis />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
